import { render } from "./SendTestModal.vue?vue&type=template&id=60f50f69&scoped=true"
import script from "./SendTestModal.vue?vue&type=script&lang=ts"
export * from "./SendTestModal.vue?vue&type=script&lang=ts"

import "./SendTestModal.vue?vue&type=style&index=0&id=60f50f69&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-60f50f69"

export default script